<template>
  <div>
    <div class="fpWarp">
      <div class="inner">
        <div class="title">
          <img src="../assets/img/mffl.png" />
          <div class="title-z4">
            <h1>商城道具疯狂送</h1>
            <p>{{freePropsData.pageDate}}</p>
          </div>
        </div>
        <div class="content">
          <h3>活动内容:</h3>
          <p>活动期间，玩家可在游戏内商城中免费购买、使用以下商品:</p>
        </div>
        <div class="bottom-pic">
          <dl class="dl_all">
            <dd class="all_tit">
              <span>所有
                <br />用户</span>
            </dd>
            <dt
              v-for="(item,index) in freePropsData.allPeople"
              :key="index"
            >
              <img :src="getImg(item)">
              <p>{{item}}</p>
            </dt>
            <dt class="hou"></dt>
          </dl>
          <dl class="dl_vip">
            <dd class="vip_tit">
              <span>VIP专属
                <br />免费道具</span>
            </dd>
            <dt
              v-for="(item,index) in freePropsData.vip"
              :key="index"
            >
              <img :src="getImg(item)">
              <p>{{item}}</p>
            </dt>
            <dt class="hou"></dt>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: "freeProps",
  data() {
    return {
      // pageDate: "1月8日——1月28日",
      // allPeople: [
      //   'M249_SAW','退魔AA12','军灵AWP','精钢AK47','精钢FN57','移动装置'
      // ],
      // vip: ["高碳怒焰风暴", "钛钢UMP9", "破军光束剑"],
      freePropAllImg: [
        { name: "M249_SAW", src: "m249swa" },
        { name: "退魔AA12", src: "tmaa12" },
        { name: "军灵AWP", src: "jlawp" },
        { name: "精钢AK47", src: "ak47" },
        { name: "精钢FN57", src: "fn57" },
        { name: "高碳怒焰风暴", src: "nyfb" },
        { name: "钛钢UMP9", src: "ump" },
        { name: "移动装置", src: "ydzz" },
        { name: "破军光束剑", src: "gsj" },
        { name: "AUG", src: "AUG" },
        { name: "破军HK21", src: "pj-hk21" },
        { name: "毛瑟M1932", src: "m1932" },
        { name: "钛钢毛瑟M1932", src: "m1932" },
        { name: "精钢Hawker-1", src: "Hawker-1" },
        { name: "破军-守备官", src: "pj-sbg" },
        { name: "静音装置", src: "jyzz" },
        { name: "USP", src: "usp" },
        { name: "破军AN94", src: "pj-an94" },
        { name: "魔煞UMP9", src: "msump9" },
        { name: "精钢QBU88", src: "pj-an94" },
        { name: "力量增幅器", src: "llzf" },



        { name: "高碳QBS09", src: "v-qbs09" },
        { name: "钛钢HK21", src: "v-hk21" },
        { name: "钛钢HK416", src: "416" },
        { name: "高碳M29", src: "v-m29" }
      ]
    };
  },
  created() {
    this.getImg();
  },
  computed:{ 
    ...mapGetters(['freePropsData'])
  },
  methods: {
    getImg(str = "M249_SAW") {
      let imgSrc = "";
      this.freePropAllImg.forEach(function(value) {
        if (value.name == str) {
          imgSrc = value.src;
        }
      });
      if (imgSrc) {
        return require("../assets/img/images/" + imgSrc + ".png");
      } else {
        console.log(str)
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.fpWarp {
  background: url("../assets/img/bg6.jpg") no-repeat top center;
  height: 1235px;
  position: relative;
  min-width: 1200px;
  .title {
    padding-top: 66px;
    .title-z4 {
      color: #000;
      font: bold 40px/46px "Microsoft YaHei";
      margin-top: -25px;
      text-align: center;

      p {
        font: bold 20px/30px "å¾®è½¯é›…é»‘";
        color: #000;
        /* margin-left: 60px; */
      }
    }
  }
  .content {
    width: 500px;
    text-align: center;
    font-size: 18px;
    margin-top: 56px;
    margin-left: 360px;
  }
  .bottom-pic {
    padding-top: 30px;
    dl {
      width: 1200px;
      overflow: hidden;
      dt {
        background: rgba(198, 200, 199, 0.7);
        filter: progid:DXImageTransform.Microsoft.Alpha(opacity=70);
        float: left;
        width: 230px;
        height: 198px;
        margin-right: 7px;
        margin-bottom: 7px;
        img {
          display: block;
          margin-top: 20px;
          margin-left: 5px;
        }
        p {
          color: #000;
          margin-right: 8px;
          text-align: right;
          font-size: 16px;
        }
      }
      dd {
        float: left;
        font-size: 32px;
        color: #fff;
        width: 186px;
        height: 198px;
        opacity: 1;
        filter: progid:DXImageTransform.Microsoft.Alpha(opacity=100);
        font-weight: 700;
        span {
          display: block;
          margin: 25px 0 0 25px;
        }
      }
      dd.all_tit {
        background: #d23e3e;
      }
      dd.vip_tit {
        background: #ebbc3a;
      }
      dt.hou {
        background: #d38281;
        width: 190px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/freeProps.vue